import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './month-picker.scss';
import { faAngleLeft, faAngleRight} from "@fortawesome/free-solid-svg-icons/index";
import { withNamespaces } from 'react-i18next';

// a select with dynamically created options
const monthOptions = [1,2,3,4,5,6,7,8,9,10,11,12];
const yearOptions = [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2028];

@withNamespaces()
@inject('store')
@observer
class MonthPicker extends Component {
    constructor(props) {
        super(props);

        this.nextMonth = this.nextMonth.bind(this);
        this.prevMonth = this.prevMonth.bind(this);
        this.changeMonth = this.changeMonth.bind(this);
        this.changeYear = this.changeYear.bind(this);
    }

    nextMonth() {
        const { budget } = this.props.store;

        let month = budget.month + 1;
        let year = budget.year;

        if (month > 12) {
            month = 1;
            year++;
        }

        budget.changeDate(year, month);
    }

    prevMonth() {
        const { budget } = this.props.store;

        let month = budget.month - 1;
        let year = budget.year;

        if (month < 1) {
            month = 12;
            year--;
        }

        budget.changeDate(year, month);
    }

    changeMonth(e) {
        const { budget } = this.props.store;
        budget.changeDate(budget.year, parseInt(e.target.value, 10));
    }

    changeYear(e) {
        const { budget } = this.props.store;

        budget.changeDate(parseInt(e.target.value, 10), budget.month);
    }

    render() {
        const { t, store } = this.props;
        const { budget } = store;
        const { year, month } = budget;
        const minDate = (year === 2018 && month === 1);
        const maxDate = (year === 2028 && month === 12);

        // TODO: Block interface if loading, because this can easily spam the server

        return (
            <Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-1 col-2 angle-container">
                            <div className="form-group">
                                {!minDate && (
                                    <FontAwesomeIcon
                                        onClick={this.prevMonth}
                                        className="pointer angle-icon"
                                        size="3x"
                                        icon={faAngleLeft}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="col-md-5 col-sm-5 col-8">
                            <div className="form-group">
                                <select name="month" value={budget.month} onChange={this.changeMonth} className="form-control month-input">
                                    {monthOptions.map(option => {
                                        return <option value={option} key={option} >{t(`MONTH.${option}`)}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-1 col-2 angle-container">
                            <div className="form-group">
                                {!maxDate && (
                                    <FontAwesomeIcon
                                        onClick={this.nextMonth}
                                        size="3x"
                                        icon={faAngleRight}
                                        className="fa-icon-margin pointer angle-icon"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <select name="year" value={budget.year} onChange={this.changeYear} className="form-control month-input">
                                    {yearOptions.map(option => {
                                        return <option value={option} key={option} >{option}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default MonthPicker;



// WEBPACK FOOTER //
// ./src/components/pickers/month-picker.js